import api from "../module_user/api/api";

let baseUrl = process.env.VUE_APP_API_URL;

async function getTrainerVideos(userId, currentPage, pageSize) {
    let response = await api.get(baseUrl + `/v2/videos?userId=${userId}&page=${currentPage}&pageSize=${pageSize}`);
    return response;
}

async function getEFVideos(requestData) {
    const params = new URLSearchParams(requestData);
    let response = await api.get(baseUrl + `/v2/videos/video-library?${params.toString()}`);
    return response;
}

async function searchTrainerVideos(userId, searchText, currentPage, pageSize, is_free) {
    let response = await api.get(baseUrl + `/v2/videos/get-ef-videos?userId=${userId}&page=${currentPage}&pageSize=${pageSize}&searchText=${searchText}&is_free=${is_free}`);
    return response;
}

async function getVideoById(id) {
    let response = await api.get(baseUrl + `/v2/videos/${id}`);
    return response;
}

async function deleteVideo(videoId) {
    let response = await api.delete(baseUrl + `/v2/videos/${videoId}`);
    return response;
}

async function updateVideo(data, videoId) {
    let response = await api.put(baseUrl + `/v2/videos/${videoId}`, data);
    return response;
}

async function addVideo(data) {
    let response = await api.post(baseUrl + "/v2/videos", data);
    return response.data;
}

async function loadReportsData(id) {
    let response = await api.get(baseUrl + "/reports/user/" + id);
    return response.data;
}

async function loadReportsVideoData(data) {
    let str = '';
    if (data && data.startDate) {
        str = str + `&startDate=${data.startDate}`;
    }
    if (data && data.endDate) {
        str = str + `&endDate=${data.endDate}`;
    }
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let response = await api.get(baseUrl + `/reports/workouts/${data.userId}?page=${data.page}&pageSize=${data.pageSize}&timezone=${timezone}${str}`);
    return response.data;
}

async function generateReports(data) {
    let response = await api.post(baseUrl + `/reports/workout-detail`, data);
    return response.data;
}

async function bulkUploadVideos(data) {
    let response = await api.post(baseUrl + '/baseline/bulk-upload', data,
        {
            'headers': {
                'Content-Type': 'multipart/form-data'
            }
        })
    return response.data;
}

async function getAllCategories(type) {

    let url = baseUrl + '/videos/get-all-categories'
    if(type){
        url = url + `?type=${type}`
    }
    let response = await api.get(url);
    return response.data;
}

async function getSessionData(requestData) {
    let response = await api.post(baseUrl + '/video-test/get-session-data', requestData);
    return response.data;
}

async function getTrainerData(baseline_folder) {
    let response = await api.post(baseUrl + '/video-test/get-trainer-data', {"baseline_folder": baseline_folder});
    return response.data;
}

async function getScoreData(sessionId) {
    let response = await api.post(baseUrl + '/video-test/get-session-score', {'sessionId': sessionId});
    return response.data;
}

async function getAllTenants() {
    let response = await api.get(baseUrl + '/videos/get-all-filter');
    return response.data;
}

async function sendBaselineStatus(message) {
    let response = await api.post(baseUrl + '/email/smb-video-status-email', message);
    return response;
}

async function getTransactions(){
    let response = await api.get(baseUrl + '/admin-billing/get-transactions');
    return response.data;
}

async function getCurrentUploadCount(userId) {
    let response = await api.get(baseUrl + `/videos/get-video-upload-count/${userId}`);
    return response.data;
}

async function getPinnedVideos() {
    let response = await api.get(baseUrl + `/v2/videos/get-pinned-videos`);
    return response.data;
}

async function pinVideo(data) {
    let response = await api.post(baseUrl + `/v2/videos/pin`, data);
    return response.data;
}

async function unPinVideo(videoId) {
    let response = await api.delete(baseUrl + `/v2/videos/un-pin/${videoId}`);
    return response;
} 

async function userList(data) {
    let response = data.search ? await api.get(baseUrl + `/reports/users?page=${data.page}&search=${data.search}`) : await api.get(baseUrl + `/reports/users?page=${data.page}`);
    return response;
} 

async function getPatientsTreatmentPlans(userId) {
    let response = await api.get(baseUrl + `/reports/users/programs?id=${userId}`);
    return response;
} 

async function getPatientTreatmentPlanDetails(data){
    let queryString = `?userId=${data.userId}&assignmentId=${JSON.parse(data.assignId)[0]}&timezone=${data.timezone}`;
    if(data.startDate){
        queryString += `&startDate=${data.startDate}`
    }
    if(data.endDate){
        queryString += `&endDate=${data.endDate}`
    }
    let response = await api.get(baseUrl + `/reports/users/treatment/details${queryString}`)
    return response
}

async function getDashboardSummary(data){
    let response = await api.get(baseUrl + `/corporate/dashboard-summary?start_date=${data.startDate?data.startDate:''}&end_date=${data.endDate?data.endDate:''}`)
    return response
}

async function getDashboardSummaryUsers(data){
    let queryString = `?page=${data.page?data.page:1}&limit=${data.limit?data.limit:10}&search=${data.search?data.search:''}&activity=${data.activity?data.activity:'loggedin'}`;
    if(data.startDate)
        queryString += `&start_date=${data.startDate}`
    if(data.endDate)
        queryString += `&end_date=${data.endDate}`
    let response = await api.get(baseUrl + `/corporate/dashboard-recent-activity${queryString}`)
    return response;
}

async function getVideoData(params){
    let queryString = `?page=${params.page}&pageSize=${params.pageSize}`;
        let response = await api.get(baseUrl + `/user-detail/workout-videos-list${queryString}`)
    return response
}

async function getVideoChartData(params){
    let queryString = `?videoId=${params.id}`;
    if(params.startDate){
        queryString += `&startDate=${params.startDate}`
    }
    if(params.endDate){
        queryString += `&endDate=${params.endDate}`
    }
    queryString += `&lang=${params.lang}`
    let response = await api.get(baseUrl + `/user-detail/workout-video-details${queryString}`)
    return response
}

async function createMessage(data){
    return await api.post(baseUrl + `/ai-report/message/create`,data);
}

async function getMessageHistory({threadId, pageSize, page}){
    return await api.get(
      baseUrl +
        `/ai-report/message/history?thread_id=${threadId}&pageSize=${pageSize}&page=${page}`
    );
}

async function getThreadList({pageSize, page}){
 return await api.get(
   baseUrl + `/ai-report/thread/list?pageSize=${pageSize}&page=${page}`
 );
}

async function createNewThread(body){
    return await api.post(baseUrl + `/ai-report/thread`, body);
}

async function updateThread(body) {
  return await api.put(baseUrl + `/ai-report/thread`, body);
}

async function deleteThread(threadId) {
  return await api.delete(baseUrl + `/ai-report/thread/`+threadId);
}

async function getMessageOutput(messageId){
 return await api.get(
   baseUrl + `/ai-report/message/output?message_id=${messageId}`
 );
}

async function messagefeedback(messageId, isLiked, feedback){
    return await api.post(
      baseUrl + `/ai-report/message/feedback`,{
        messageId, isLiked, feedback
      }
    );
}

async function SupportContent(params) {
    let queryString = ''
    if(params && params.search){
        queryString+=`?search=${params.search}`;
    }
    let response = await api.get(baseUrl + `/support-content${queryString}`);
    return response
}

async function getAchievementData({page, pageSize}){
    let response = await api.get(baseUrl + `/user-achievement/list?page=${page}&pageSize=${pageSize}`)
    return response;
}

async function getAchievementPointData(){
    let response = await api.get(baseUrl + `/user-achievement/point-history`)
    return response.data
}


async function getTotalPoints() {
  let response = await api.get(baseUrl + `/user-achievement/total-points`);
  return response.data;
}

async function getCouponData(){
    let response = await api.get(baseUrl + `/user-coupon/list`);
    return response.data;
}

async function getCouponHistoryList(){
    let response = await api.get(baseUrl + `/user-coupon/redeem-list`);
    return response.data;
}

async function redeemCoupon(coupon_id){
    let response = await api.post(baseUrl + `/user-coupon/redeem`, {
        coupon_id
    });
    return response.data;
}

async function sendUserNotification(data){
    let response = await api.post(baseUrl + "/notification/send-in-app-notification", data);
    return response.data;
}

export default {
    getTrainerVideos,
    getVideoById,
    deleteVideo,
    updateVideo,
    addVideo,
    bulkUploadVideos,
    getAllCategories,
    getSessionData,
    getTrainerData,
    getScoreData,
    loadReportsData,
    loadReportsVideoData,
    generateReports,
    searchTrainerVideos,
    getAllTenants,
    sendBaselineStatus,
    getEFVideos,
    getCurrentUploadCount,
    getTransactions,
    getPinnedVideos,
    pinVideo,
    unPinVideo,
    userList,
    getPatientsTreatmentPlans,
    getPatientTreatmentPlanDetails,
    getDashboardSummary,
    getDashboardSummaryUsers,
    getVideoData,
    getVideoChartData,
    createMessage,
    getMessageHistory,
    getThreadList,
    createNewThread,
    updateThread,
    deleteThread,
    getMessageOutput,
    messagefeedback,
    SupportContent,
    getAchievementData,
    getAchievementPointData,
    getTotalPoints,
    getCouponData,
    getCouponHistoryList,
    redeemCoupon,
    sendUserNotification,
}
